// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarDeleteSelectedButton.tsx
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";

interface DataGridToolbarDeleteSelectedButtonProps
  extends DataGridToolbarProps {}

export default function DataGridToolbarDeleteSelectedButton({
  deleteSelectedItems,
  trashType,
  buttonSize,
}: DataGridToolbarDeleteSelectedButtonProps) {
  return (
    <DataGridToolbarButtonContainer>
      <Tooltip
        title={I18n.t(
          trashType === "onlyTrashed"
            ? "App.deleteSelectedTrash"
            : "App.deleteSelected"
        )}
      >
        <IconButton
          size={buttonSize}
          color="error"
          style={{ marginLeft: -4 }}
          onClick={() => deleteSelectedItems && deleteSelectedItems()}
        >
          {trashType === "onlyTrashed" ? (
            <DeleteForeverOutlinedIcon fontSize={buttonSize} />
          ) : (
            <DeleteIcon fontSize={buttonSize} />
          )}
        </IconButton>
      </Tooltip>
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarDeleteSelectedButton.tsx